import React, { useEffect, useState } from 'react';

import { Banner, RadioButton, useT } from '@repo/common';
import { ReactComponent as InfoIcon } from '@repo/common/assets/icons/20px/icon_20px_info_outline.svg';
import { getAllCareers } from '../../../api/career/career.api';
import ResumeRow from './ResumeRow';

const ChangeResumeModalContent = ({ selectedResume, onSelectResume }) => {
  const t = useT();
  const [resumeData, setResumeData] = useState(null);

  useEffect(() => {
    const fetchCareers = async () => {
      try {
        const data = await getAllCareers();
        setResumeData(data);

        if (!selectedResume) {
          const standard = data.find((r) => r.standard);
          if (standard) {
            onSelectResume(standard);
          }
        }
      } catch (e) {
        console.error(e);
        setResumeData([]);
      }
    };

    fetchCareers();
  }, [selectedResume, onSelectResume]);

  if (resumeData == null) return;

  return (
    <div className='flex flex-col gap-4'>
      <Banner
        size='s'
        icon={<InfoIcon />}
        label={t(
          'Selecting a resume here will set it as your standard resume for applications.',
          '여기에서 이력서를 선택하면 지원 시 기본 이력서로 설정됩니다.',
        )}
      />

      <div className='flex flex-col w-full'>
        {resumeData.length > 0 && (
          <div className='flex flex-col gap-4 w-full'>
            {resumeData.map((resume) => (
              <div key={resume.id} className='flex items-center gap-3 w-full'>
                <RadioButton
                  checked={resume.id === selectedResume?.id}
                  onChange={() => onSelectResume(resume)}
                />

                <div className='flex-1 flex flex-col gap-2'>
                  <div className='bg-grayscale-gray00 rounded-lg tabletH:border tabletH:border-grayscale-gray03'>
                    <ResumeRow resume={resume} status={'edit'} />
                  </div>

                  {resume.score < 100 && resume.id === selectedResume?.id && (
                    <div className='text-text-failed typo-b12Strong tabletH:typo-b14Strong'>
                      {t(
                        'This resume is not fully completed. We recommend applying with a 100% complete resume for better results.',
                        '이 이력서는 아직 완성되지 않았습니다. 더 좋은 결과를 위해 100% 완성된 이력서로 지원하시는 것을 권장합니다.',
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChangeResumeModalContent;
